const $win = $(window);
const $doc = $(document);

$win.on('load', function() {
	const $images = $('.product__images');

	$images.find('.featured-images').slick({
		slidesToShow: 1,
		arrows: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					dots: true
				}
			}
		]
	});

	$images.find('.thumbs').slick({
		slidesToShow: 4,
		arrows: false,
		asNavFor: '.featured-images',
		focusOnSelect: true, 
		responsive: [
			{
				breakpoint: 980,
				settings: {
					slidesToShow: 3,
				}
			}
		]
	});
})



// WEBPACK FOOTER //
// ./../src/assets/js/product-sliders.js